import { PagedResult } from '../../shared/model/paged-result.model';
import { MembershipLevelBenefit } from './membership-level-benefit.model';

export class MembershipLevelBenefitSearchResult extends PagedResult {
  public Result: Array<MembershipLevelBenefit>;

  public constructor() {
    super();

    this.Result = new Array<MembershipLevelBenefit>();
  }
}
